import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { isTestEnv } from "@/lib/env";

import { api } from "./services/api";
// Import enhancedApi to ensure endpoint overrides (invalidatesTags,
// onQueryStarted, keepUnusedDataFor) are applied before any hooks run.
// enhanceEndpoints mutates the generatedApi instance in place.
import "./services/enhancedApi";
import { generatedApi } from "./services/generatedApi";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [generatedApi.reducerPath]: generatedApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([api.middleware, generatedApi.middleware]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

if (!isTestEnv) {
  setupListeners(store.dispatch);
}
